import { Component, OnInit, Input } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NzModalRef } from 'ng-zorro-antd/modal'
import storeeeee from 'store'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzMessageService } from 'ng-zorro-antd/message'
import { differenceInCalendarDays } from 'date-fns'
import { VoucherForm } from 'src/app/services/interface/voucher.model'
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload'
import { ApiService } from 'src/app/services/api.service'
import {
  HttpClient,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http'
import { Observable, Observer } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { VoucherService } from 'src/app/services/onapps/voucher.service'
const _ = require('lodash')

interface options {
  id: number
  name: string
}

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

@Component({
  selector: 'app-edit-new-user-lists',
  templateUrl: './edit-new-user-lists.component.html',
  styleUrls: ['./edit-new-user-lists.component.css'],
})
export class EditNewUserListsComponent implements OnInit {
  isLoading: boolean = true
  isLoadingOptions: boolean = false
  fileList: NzUploadFile[] = []
  listOfDeptOption: string[] = ['ONDELIVERY', 'ONMARKET', 'ONTICKET', 'ONAPPS']
  listOfServiceOption: Array<options>
  isOndelivery: boolean = false
  listOfOriginCityOption: Array<{ city_id: string; city_name: string }> = []
  listOfDestinationCityOption: Array<{ city_id: string; city_name: string }> = []
  selectedOriginCity: Array<{ city_id: string; city_name: string }> = []
  selectedDestinationCity: Array<{ city_id: string; city_name: string }> = []
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private onappsService: VoucherService,
    private notification: NzNotificationService,
    private msg: NzMessageService,
    private modal: NzModalRef,
    private http: HttpClient,
  ) {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      type: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.required])],
      status: [null, Validators.compose([Validators.required])],
      value: [null, Validators.compose([Validators.required, Validators.min(1)])],
      quota: [null /*, Validators.compose([Validators.required, Validators.min(1)])*/],
      quota_per_user: [null /*, Validators.compose([Validators.required, Validators.min(1)])*/],
      service: [null],
      origin_city: [null],
      destination_city: [null],
      department: [null, Validators.compose([Validators.required])],
      startDate: [null, Validators.compose([Validators.required])],
      dueDate: [null, Validators.compose([Validators.required])],
      image: [null, Validators.compose([Validators.required])],
      minDiscount: [null],
      maxDiscount: [null],
      isFcm: [null],
    })
  }

  disabledDate = (current: Date): boolean => {
    // console.log(differenceInCalendarDays(new Date(),current))
    // Can not select days before today and today
    return differenceInCalendarDays(current, new Date()) < 0
  }

  @Input() id: string
  form: FormGroup

  ngOnInit(): void {
    this.fetchVoucherDetails()
    this.form.statusChanges.subscribe(state => {
      this.modal.updateConfig({ nzOkDisabled: state === 'INVALID' })
    })
    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }
    // this.form.controls['city'].valueChanges.pipe(debounceTime(500)).subscribe(r => {
    //   if (typeof r == 'string') {
    //     this.destinationSearch(r.toLowerCase())
    //   } else {
    //     this.destinationSearch(r.city_name.toLowerCase())
    //   }
    // })
    this.isLoadingOptions = true
    this.onappsService.serviceList().subscribe(r => {
      this.listOfServiceOption = r
      this.isLoadingOptions = false
    })
  }

  departmentSelect(event) {
    this.isOndelivery = false
    for (var i = 0; i < event.length; i++) {
      if (event[i] === 'ONDELIVERY') {
        this.isOndelivery = true
      }
    }
  }

  originSearch(keyword: string): void {
    this.isLoadingOptions = true
    this.onappsService.destinationSearchNew(keyword).subscribe(r => {
      var value = []
      for (let i = 0; i < r.length; i++) {
        if (r[i].city_name.toLowerCase().startsWith(keyword)) {
          value.push({ city_id: r[i].city_id, city_name: r[i].city_name })
        }
      }

      this.listOfOriginCityOption = _.uniqBy(value, 'city_id')

      if (this.selectedOriginCity.length > 0) {
        this.listOfOriginCityOption = this.listOfOriginCityOption.filter(val => {
          return !this.selectedOriginCity.find(val2 => {
            return val.city_id === val2.city_id
          })
        })
      }
      this.isLoadingOptions = false
    })
  }

  destinationSearch(keyword: string): void {
    this.isLoadingOptions = true
    this.onappsService.destinationSearchNew(keyword).subscribe(r => {
      var value = []
      for (let i = 0; i < r.length; i++) {
        if (r[i].city_name.toLowerCase().startsWith(keyword)) {
          value.push({ city_id: r[i].city_id, city_name: r[i].city_name })
        }
      }

      this.listOfDestinationCityOption = _.uniqBy(value, 'city_id')

      if (this.selectedDestinationCity.length > 0) {
        this.listOfDestinationCityOption = this.listOfDestinationCityOption.filter(val => {
          return !this.selectedDestinationCity.find(val2 => {
            return val.city_id === val2.city_id
          })
        })
      }
      this.isLoadingOptions = false
    })
  }

  originCitySelect(event: any) {
    this.selectedOriginCity = event
  }

  destinationCitySelect(event: any) {
    this.selectedDestinationCity = event
  }

  fetchVoucherDetails() {
    this.isLoading = true
    this.onappsService.detailVoucher(this.id).subscribe(
      res => {
        if (res.image !== null) {
          this.fileList = [res.image]
          res.image = true
        }
        if (res.service) {
          res.service = res.service.map((r: string) => {
            return parseInt(r)
          })
        }
        this.form.patchValue(res)
        this.form.controls.origin_city.patchValue(res.originCity)
        this.form.controls.destination_city.patchValue(res.destinationCity)
        if (res.originCity) {
          this.selectedOriginCity = res.originCity
          this.listOfOriginCityOption = res.originCity
        }
        if (res.destinationCity) {
          this.selectedDestinationCity = res.destinationCity
          this.listOfDestinationCityOption = res.destinationCity
        }
        for (const i in this.form.controls) {
          if (this.form.controls.hasOwnProperty(i)) {
            this.form.controls[i].markAsDirty()
            this.form.controls[i].updateValueAndValidity()
          }
        }
        this.isLoading = !this.isLoading
      },
      err => {
        this.notification.error('Error', err.error.message)
      },
    )
  }

  submitForm(): boolean {
    this.isLoading = true
    this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
    var isUploading = false
    for (let i = 0; i < this.fileList.length; i++) {
      if (['uploading', 'error'].includes(this.fileList[i].status)) {
        isUploading = true
        break
      }
      if (isUploading) break
    }

    for (const i in this.form.controls) {
      if (this.form.controls.hasOwnProperty(i)) {
        this.form.controls[i].markAsDirty()
        this.form.controls[i].updateValueAndValidity()
      }
    }

    if (!isUploading && this.form.valid) {
      var formSubs: VoucherForm = this.form.value
      formSubs.id = this.id
      if (this.fileList[0] != null) {
        if (this.fileList[0].status === 'done') {
          formSubs.image = {
            name: this.fileList[0].response?.name || this.fileList[0].name,
            status: this.fileList[0].status,
            url: this.fileList[0].response?.url || this.fileList[0].url,
            uid: this.fileList[0].uid,
          }
        }
      }
      this.onappsService.updateVoucher(formSubs).subscribe(
        r => {
          this.notification.success('Success', r.message)
          this.isLoading = false
          this.modal.destroy()
          // this.fetchVoucherDetails()
          return true
        },
        err => {
          this.notification.error('Error', err.error.message)
          this.isLoading = false
          this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
          // this.fetchVoucherDetails()
          return false
        },
      )
    } else {
      this.msg.error(
        isUploading ? 'Please wait until all files uploaded' : 'Please Fill Blank Form',
      )
      this.isLoading = false
      this.modal.updateConfig({ nzOkLoading: this.isLoading, nzCancelDisabled: this.isLoading })
      return false
    }
  }

  handleBeforeUpload = (file: NzUploadFile): boolean => {
    if (file.size <= 11534336) {
      return true
    } else {
      this.msg.error('File too Large')
      return false
    }
  }

  customUploadReq = (item: NzUploadXHRArgs) => {
    const formData = new FormData()
    formData.append('file', item.file as any)

    const req = new HttpRequest(
      'POST',
      this.apiService.API_SUNSHINE_SERVER + '/api/upload/temp',
      formData,
      {
        headers: new HttpHeaders({
          authorization: 'Bearer ' + storeeeee.get('accessToken'),
        }),
        reportProgress: true,
        withCredentials: false,
      },
    )

    return this.http.request(req).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total > 0) {
            ;(event as any).percent = (event.loaded / event.total) * 100 // tslint:disable-next-line:no-any
          }
          item.onProgress!(event, item.file)
        } else if (event instanceof HttpResponse) {
          item.onSuccess!(event.body, item.file, event)
        }
      },
      err => {
        // console.log(err)
        /* error */
        item.onError!(err, item.file)
      },
    )
  }

  handleRemove = (file: NzUploadFile) =>
    new Observable((observer: Observer<boolean>) => {
      this.form.patchValue({ image: null })
      observer.next(true)
      observer.complete()
    })

  handleDownload = (file: NzUploadFile): void => {
    window.open((file.response?.url || file.url) + '?s=download', '_blank')
  }

  previewImage: string | undefined = ''
  previewVisible = false

  handlePreview = async (file: NzUploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj!)
    }
    this.previewImage = file.response?.url || file.url || file.preview
    this.previewVisible = true
  }

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`)
      this.form.patchValue({ image: true })
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`)
    }
  }
}
